import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'hourminsec'})

export class HourMinSec implements PipeTransform {
  transform(value: number): string {
    const hour: number = Math.floor(value / 3600);
    const minutes: number = Math.floor((value - hour * 3600) / 60);
    const seconds: number =  Math.floor(value - hour * 3600 - minutes * 60);
    if(value >= 3600){
      return this.zeroPadding(hour, 1) + ':' + this.zeroPadding(minutes, 2) + ':' + this.zeroPadding(seconds, 2);
    }
    else{
      return this.zeroPadding(minutes, 2) + ':' + this.zeroPadding(seconds, 2);
    }
  }
  
  zeroPadding(num:number, length:number){
      return ('0000000000' + num).slice(-length);
  }  
}
